import React, { useState } from 'react'
import Dashboard from '../components/Menu/Dashboard';
import LoadingScreen from '../components/Complements/LoadingScreen';
import UserPanelInfoMobile from '../components/Complements/UserPanelInfoMobile';
import { isMobile, osName, osVersion } from 'react-device-detect';
import DialogOTP from '../components/Complements/DialogOTP';
import MessageInfo from '../components/Complements/MessageInfo';
import TaxeRenderBody from '../components/Taxes/TaxeRenderBody';
import Voucher from '../components/Transfers/Voucher';
import TaxePanel from '../components/Taxes/TaxePanel';
import DonationsFoundationsForm from "../components/DonationsFoundations/DonationsFoundationsForm"
import { feathersCreateData } from '../services';
import { history } from '../helpers/history';
import { validateIp } from '../functions/store';
import { connect } from "react-redux";
import { urlVoucher } from '../services/urls';
import moment from 'moment'
import { encrypt, sendMobile } from '../functions/mobile';
import { getBalanceUser } from "../actions/balances";
import { isEmpty } from '../functions/arrays';
import { changeStatusUser } from './../actions/codes';
import { handleDownloadMovil, handleDownloadWeb } from '../functions/handle-download';


const FoundationsContainer = props => {

    const { user, balances, handleOpenSnack, devices, foundations } = props

    const [ accountSelected, setAccountSelected ] = useState(balances[0]);
    const [ loading, setLoading ] = useState(false)
    const [ showvoucher, setShowvoucher ] = useState(false)
    const [ OTP, setOTP ] = useState({
        id: '',
        openOtp: false,
        type: '',
        code: ''
    })
    const [ foundationSelected, setFoundationSelected ] = useState({})
    //const [ contAttemptsAcademyProcess, setcontAttemptsAcademyProcess ] = useState(0)
    const [ showDialogAccounts, setShowDialogAccounts ] = useState(false)
    const [ dataDonationsForm, setDataDonationsForm ] = useState({
        amount : ""
    })
    const [ dataVoucher, setDataVoucher ] = useState({})

    const updateBalanceAccountSelected = async () => {

        setLoading(true)
        const response = await props.getBalanceUser({NumeroCliente: user.NumeroCliente, SecuencialEmpresa: 1, EstaActiva: true})
        //console.log(response)

        const { data } = response.payload;

        const responseFilterAccount = data.filter ( (item) => item.Codigo === accountSelected.Codigo)

        setAccountSelected(responseFilterAccount[0])
        setLoading(false)
    }

    const handleRequestCode = async (values) => {
        try {
            
            if(foundationSelected.Secuencial){
                setLoading(true)
                setDataDonationsForm({
                    amount : parseFloat(values.amount).toFixed(2)
                })
                const { ip } = devices
                const {getDeviceData, updateIpDevice } = props
                let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)
                let deviceData =`${osName} ${osVersion}`
                let mac = 'NAVEGADOR'
                if (!isEmpty(devices)) {
                    const { device, ip: ipDevice, mac: macDevice } = devices
                    deviceData = device;
                    ipSend = ipDevice;
                    mac = macDevice;
                } 

                const sendData = encrypt(JSON.stringify({
                    emited: 'NAVCREATECODE', type: 30, deviceData, ip: ipSend, mac
                }))
                feathersCreateData('codes-recovery', { sendData })()
                    .then((res) => {
                        // console.log(res)
                        //const { result, data } = res
                        setOTP({
                            ...OTP,
                            //id: data.sequence,
                            //code: '' + result,
                            type: 'DONATIONS_FOUNDATIONS',
                            openOtp: true
                        })
                        setLoading(false)
                    }).catch(err => {
                        //console.log(err)
                        setLoading(false)
                        handleOpenSnack('No se ha podido realizar la transacción. Por favor intente nuevamente', 'error')
                    })
            }else{
                handleOpenSnack("Debe seleccionar una fundación", "info")
            }
        } catch (error) {
            //console.log(error)
            handleOpenSnack('Error al solicitar codigo.', 'info')
        }
        
    }

    const handleDownloadVoucher = () => {
        feathersCreateData('voucher-document', { name:accountSelected.Codigo, document: dataVoucher.DocumentoTransaccion, name_voucher: dataVoucher.name_voucher})().then(res => {
            if (res.error) {
                handleOpenSnack(res.message, 'error')
            } else {
                if (localStorage.caja_app !== undefined) {
                    // let send = {
                    //     type: 'action',
                    //     action: 'download_voucher',
                    //     data: urlVoucher+res.voucher+".pdf",
                    //     messageSend: 'Comprobante'
                    // }
                    // sendMobile(JSON.stringify(send))
                    handleDownloadMovil(urlVoucher, res.voucher)
                    
                } else {
                    // window.open(urlCertificates+nameFile+".pdf", '_blank');
                    handleDownloadWeb(urlVoucher, res.voucher)
                }
            }
        }).catch(err => handleOpenSnack('No se ha encontrado el documento', 'error') )
    }

    const handleFoundationChange = (e) => {

        setFoundationSelected(e.target.value)

    }

    const handleOTPCompare = async({data}) => {
        // const { id } = auth
        setLoading(true)
        //const { code } = OTP
        try {

            const {ip, device, mac} = devices

            const sendData = encrypt(JSON.stringify({
                ip,
                mac,
                device,
                type : 30,
                inputOtp : data
            }))

            const responseValidateCode = await feathersCreateData("code-validation", { sendData })()

            //console.log("Respuesta: ", responseValidateCode)

            //const responseValidateCodeDecrypt = JSON.parse(decrypt(responseValidateCode.responseData))

            //console.log(responseValidateCodeDecrypt)

            const { error, message, type : typeMessage, viewDialogOtp } = responseValidateCode;

            if (error === false) {

                const sendDataFoundations = encrypt(JSON.stringify({
                    NroDeCuenta : accountSelected.Codigo,
                    SecuencialFundacion : foundationSelected.Secuencial,
                    SecuencialCuenta : accountSelected.Secuencial,
                    MontoPagar : dataDonationsForm.amount,
                    dataDevice : {
                        ip,
                        device,
                        mac
                    },
                    otp : data
                }))

                const response = await feathersCreateData("core-server", {
                    func : "PROCESS_DONATIONS_FOUNDATIONS",
                    service : "FOUNDATIONS",
                    data : sendDataFoundations
                })() 

                //console.log(response)accountSelected.Codigo

                const { error, data : responseDataVoucher } = response;

                //console.log(responseDataVoucher)

                setOTP({
                    ...OTP,
                    openOtp : false
                })

                if(error === false){

                    updateBalanceAccountSelected()

                    setDataVoucher(responseDataVoucher)

                    setShowvoucher(true)

                    handleOpenSnack("Se ha realizado correctamente la donación", "success")

                }else{

                    handleOpenSnack("Ha ocurrido un error al realizar la donación", "error")

                }

                setLoading(false)

            } else {
                if(viewDialogOtp === false){
                    setOTP({...OTP, openOtp: false})
                }
                setLoading(false)
                handleOpenSnack(message, typeMessage);
            }
        } catch (error) {
            //console.log(error)
            setOTP({
                ...OTP,
                openOtp : false
            })
            setLoading(false)
            handleOpenSnack('No se ha podido realizar la donacion.', 'error')
        }
    }

    const handleCancel = () => {
        history.push('/')
    }

    const renderProcess = () => {

            return  <div>
                        <DonationsFoundationsForm
                            onSubmit = { handleRequestCode }
                            cancelButton = { handleCancel }
                            foundationSelected = { foundationSelected }
                            handleFoundationChange = { handleFoundationChange }
                            foundations = { foundations }
                        />
                    </div>
        
    }

    const handleChangeInputOtp = (valueinput) => {
        if(valueinput.target.value.toString().length === 4){
            handleOTPCompare({data : valueinput.target.value.toString()});
        }
    }

    const handleAccountChange = () => {
        setShowDialogAccounts(!showDialogAccounts)
    }

    const handleNewPayment = () => {
        setShowvoucher(false)
    }

    const renderBody = () => {
        if (isMobile) {
            if (isEmpty(accountSelected)) {
                return  <MessageInfo type='info' text={'No dispone de una cuenta para la donación.'} />
            } else {
                return  <UserPanelInfoMobile 
                                user = { user }
                                balances = { balances } 
                                accountSelected = { accountSelected }
                                changeAccount = { setAccountSelected }
                                handleAccountChange = {handleAccountChange}
                                dialog = {showDialogAccounts}
                            >
                            {(showvoucher === false) ? renderProcess() : <Voucher 
                                                                                amount = {dataVoucher.MontoPagar}
                                                                                titleheader = { "Valor donado" }
                                                                                title = { "Comprobante" }
                                                                                textButtonCancel = { "Nueva Donación" }
                                                                                handleCancel = { handleNewPayment }
                                                                                databodyone = { [
                                                                                    {
                                                                                        title : "Fundación:",
                                                                                        value : dataVoucher.NombreFundacion,
                                                                                        order : 1
                                                                                    },
                                                                                    {
                                                                                        title : "# Cliente:",
                                                                                        value : dataVoucher.NroDeCliente,
                                                                                        order : 2
                                                                                    },
                                                                                    {
                                                                                        title : "Número de Cuenta:",
                                                                                        value : dataVoucher.NroDeCuenta,
                                                                                        order : 3
                                                                                    },
                                                                                    {
                                                                                        title : "Socio:",
                                                                                        value : dataVoucher.NombreCliente,
                                                                                        order : 4
                                                                                    },
                                                                                    {
                                                                                        title : "Fecha:",
                                                                                        value : moment(dataVoucher.FechaPago).format("YYYY/MM/DD"),
                                                                                        order : 5
                                                                                    },
                                                                                    {
                                                                                        title : "No. de transacción:",
                                                                                        value : dataVoucher.DocumentoTransaccion,
                                                                                        order : 6
                                                                                    }
                                                                                ] }
                                                                                handleDownloadVoucher = { handleDownloadVoucher }
                                                                                handleDownloadDevice = { () => {
                                                                                    try {
                                                                                        feathersCreateData('voucher-document', { name:accountSelected.Codigo, document: dataVoucher.DocumentoTransaccion, name_voucher: dataVoucher.name_voucher})().then(res => {
                                                                                            if (res.error) {
                                                                                                handleOpenSnack(res.message, 'error')
                                                                                            } else {
                                                                                                let send = {
                                                                                                    type: 'action',
                                                                                                    action: 'export_voucher',
                                                                                                    data: urlVoucher+res.voucher+".pdf",
                                                                                                    nameFile: res.voucher,
                                                                                                    extension: 'pdf',
                                                                                                    messageSend: 'DONACION'
                                                                                                }
                                                                                                sendMobile(JSON.stringify(send))
                                                                                            }
                                                                                        }).catch(err => handleOpenSnack('No se ha encontrado el documento', 'error') )
                                                                                        
                                                                                    } catch (error) {
                                                                                        //console.log(error)
                                                                                    }
                                                                                }}
                                                                            />
                                        
                            }
                        </UserPanelInfoMobile>
            }
            
        } else {
            if (isEmpty(accountSelected)) {
                return  <MessageInfo type='info' text={'No dispone de una cuenta para la donación.'} />
            } else {
                return  <TaxeRenderBody
                            user = { user }
                            balances = { balances } 
                            accountSelected = { accountSelected }
                            changeAccount = { setAccountSelected } >
                                <TaxePanel>
                                    { 
                                        (showvoucher === false) ? renderProcess() : <Voucher 
                                                                                            amount = {dataVoucher.MontoPagar}
                                                                                            titleheader = { "Valor donado" }
                                                                                            title = { "Comprobante" }
                                                                                            textButtonCancel = { "Nueva Donación" }
                                                                                            handleCancel = { handleNewPayment }
                                                                                            databodyone = { [
                                                                                                {
                                                                                                    title : "Fundación:",
                                                                                                    value : dataVoucher.NombreFundacion,
                                                                                                    order : 1
                                                                                                },
                                                                                                {
                                                                                                    title : "# Cliente:",
                                                                                                    value : dataVoucher.NroDeCliente,
                                                                                                    order : 2
                                                                                                },
                                                                                                {
                                                                                                    title : "Número de Cuenta:",
                                                                                                    value : dataVoucher.NroDeCuenta,
                                                                                                    order : 3
                                                                                                },
                                                                                                {
                                                                                                    title : "Socio:",
                                                                                                    value : dataVoucher.NombreCliente,
                                                                                                    order : 4
                                                                                                },
                                                                                                {
                                                                                                    title : "Fecha:",
                                                                                                    value : moment(dataVoucher.FechaPago).format("YYYY/MM/DD"),
                                                                                                    order : 5
                                                                                                },
                                                                                                {
                                                                                                    title : "No. de transacción:",
                                                                                                    value : dataVoucher.DocumentoTransaccion,
                                                                                                    order : 6
                                                                                                }
                                                                                            ] }
                                                                                            handleDownloadVoucher = { handleDownloadVoucher }
                                                                                            handleDownloadDevice = { () => {
                                                                                                try {
                                                                                                    feathersCreateData('voucher-document', { name:accountSelected.Codigo, document: dataVoucher.DocumentoTransaccion, name_voucher: dataVoucher.name_voucher})().then(res => {
                                                                                                        if (res.error) {
                                                                                                            handleOpenSnack(res.message, 'error')
                                                                                                        } else {
                                                                                                            let send = {
                                                                                                                type: 'action',
                                                                                                                action: 'export_voucher',
                                                                                                                data: urlVoucher+res.voucher+".pdf",
                                                                                                                nameFile: res.voucher,
                                                                                                                extension: 'pdf',
                                                                                                                messageSend: 'DONACION'
                                                                                                            }
                                                                                                            sendMobile(JSON.stringify(send))
                                                                                                        }
                                                                                                    }).catch(err => handleOpenSnack('No se ha encontrado el documento', 'error') )
                                                                                                } catch (error) {
                                                                                                    //console.log(error)
                                                                                                }
                                                                                            }}
                                                                                        />
                                        
                                    }
                                </TaxePanel>  
                        </TaxeRenderBody>
            }
            
        }
    }

    return (
        <div>
            <Dashboard
                title= "Dashboard"
                body = { renderBody() }
                multiple = { false }
            />
            <LoadingScreen open={loading} />
            <DialogOTP
                openDialogOTP= { OTP.openOtp }
                onCloseDialogOTP = { () => setOTP({...OTP, openOtp: false})}
                initialTime = { Date.now()}
                loading = {loading}
                showQR = {false}
                OTPSubmit = { handleOTPCompare }
                onKeyPress = { handleChangeInputOtp }
            />
        </div>
    )
}

export default connect(null, {
    getBalanceUser,
    changeStatusUser
} )(FoundationsContainer)
